var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46849 11.3903C5.79194 11.1316 5.84438 10.6596 5.58562 10.3361L1.96044 5.80466L5.58562 1.27318C5.84438 0.949734 5.79194 0.477764 5.46849 0.219007C5.14505 -0.0397501 4.67308 0.0126915 4.41432 0.336138L0.414321 5.33614C0.19519 5.61005 0.19519 5.99927 0.414321 6.27318L4.41432 11.2732C4.67308 11.5966 5.14505 11.6491 5.46849 11.3903Z",
    fill: "#838BB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow4);
export default __webpack_public_path__ + "static/media/icon-arrow-4.0ae34224ca1d326641cc2f68ab7259e2.svg";
export { ForwardRef as ReactComponent };